// https://vitejs.dev/config/#build-polyfillmodulepreload
import 'vite/modulepreload-polyfill';

// Vue
import { createApp } from 'vue';
// import { createLogger } from 'vue-logger-plugin'
// import './styles';

import App from "./app.vue";
import router from "./router";
import { createPinia } from 'pinia';
const pinia = createPinia();

const app = createApp(App);
app.use(pinia).use(router).mount('#app');

